import { render, staticRenderFns } from "./GraficoVelocidad.vue?vue&type=template&id=124c52f0&scoped=true&"
import script from "./GraficoVelocidad.vue?vue&type=script&lang=js&"
export * from "./GraficoVelocidad.vue?vue&type=script&lang=js&"
import style0 from "./GraficoVelocidad.vue?vue&type=style&index=0&id=124c52f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124c52f0",
  null
  
)

export default component.exports